import { useState, useEffect } from 'react';
import type { ViewportSize } from '@/types';

/**
 * Hook that provides current viewport dimensions,
 * updated on window resize.
 */
export const useViewportSize = (): ViewportSize => {
  const [size, setSize] = useState<ViewportSize>(() => getViewportSize());

  useEffect(() => {
    const handleResize = () => {
      setSize(getViewportSize());
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return size;
};

/** Get current viewport dimensions */
const getViewportSize = (): ViewportSize => ({
  width: window.innerWidth,
  height: window.innerHeight,
});
